import environment from "@menu-environment";
import { MenuSite } from "@menu/core/types";
import imageUrl from "./image-url";
import imageSrc from "./image-src";

const getChannelImage = (site: MenuSite) => {
    if (!environment.menu.useSampleData) {
        return imageSrc(site.image);
    }

    //Could potentially use images from assets rather than from Umbraco
    //as the images are converted to webp, so could use higher quality
    //but this is essentially disabled

    const images = [
        "africa-magic",
        // "channel-o",
        "kyknet",
        "m-net",
        "mzansi-magic",
        "super-sport"
    ];

    const filename = site.title.toLowerCase().split(" ").join("-");

    if (images.includes(filename)) {
        return imageUrl(`${filename}.png`);
    }

    return imageSrc(site.image);
}

export default getChannelImage;